/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigResponse
 */
export interface ConfigResponse {
    /**
     * 
     * @type {number}
     * @memberof ConfigResponse
     */
    distanceDeliveryMax: number;
    /**
     * 
     * @type {number}
     * @memberof ConfigResponse
     */
    distancePickupMax: number;
}

/**
 * Check if a given object implements the ConfigResponse interface.
 */
export function instanceOfConfigResponse(value: object): value is ConfigResponse {
    if (!('distanceDeliveryMax' in value) || value['distanceDeliveryMax'] === undefined) return false;
    if (!('distancePickupMax' in value) || value['distancePickupMax'] === undefined) return false;
    return true;
}

export function ConfigResponseFromJSON(json: any): ConfigResponse {
    return ConfigResponseFromJSONTyped(json, false);
}

export function ConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'distanceDeliveryMax': json['distanceDeliveryMax'],
        'distancePickupMax': json['distancePickupMax'],
    };
}

export function ConfigResponseToJSON(json: any): ConfigResponse {
    return ConfigResponseToJSONTyped(json, false);
}

export function ConfigResponseToJSONTyped(value?: ConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'distanceDeliveryMax': value['distanceDeliveryMax'],
        'distancePickupMax': value['distancePickupMax'],
    };
}

